import React from "react";
import { Link } from "react-router-dom";
import {
  Code, Megaphone, Cpu, BarChart3, Lightbulb, PenLine, Smartphone,
  UserCircle2, Plane, Wheat, Building2, Leaf, BookOpen, ArrowRight, Clock
} from "lucide-react";
import MarketingHeader from "../components/marketing/MarketingHeader";
import Footer from "../components/marketing/Footer";

export const PROGRAMS = [
  { id: "career-entrepreneurship", icon: Lightbulb, name: "Career & Entrepreneurship Development", duration: "120 Hours", price: 315, desc: "Build career-readiness, idea validation, business planning, pitching and startup fundamentals." },
  { id: "technology-ai", icon: Cpu, name: "Technology & AI Foundations", duration: "120 Hours", price: 315, desc: "Introduction to AI, ML basics, Python programming, and emerging technologies." },
  { id: "digital-skills-marketing", icon: Megaphone, name: "Digital Skills & Marketing", duration: "120 Hours", price: 315, desc: "Master SEO, social media, Google Ads, analytics, and content marketing strategies." },
  { id: "web-development", icon: Code, name: "Web Development", duration: "120 Hours", price: 315, desc: "Build modern, responsive websites using HTML, CSS, JavaScript, React, and Node.js." },
  { id: "digital-literacy", icon: Smartphone, name: "Digital Literacy", duration: "120 Hours", price: 315, desc: "Computer fundamentals, internet usage, online safety, and digital tools." },
  { id: "financial-literacy", icon: BarChart3, name: "Financial Literacy", duration: "120 Hours", price: 315, desc: "Personal finance, investing, taxation, budgeting, and basic accounting principles." },
  { id: "tourism", icon: Plane, name: "Tourism", duration: "120 Hours", price: 315, desc: "Travel industry, hospitality, tour planning, and destination management." },
  { id: "agriculture", icon: Wheat, name: "Agriculture", duration: "120 Hours", price: 315, desc: "Modern farming, sustainable agriculture, agritech, and rural development." },
  { id: "yoga", icon: Leaf, name: "Yoga", duration: "120 Hours", price: 315, desc: "Asanas, pranayama, meditation, yoga philosophy and practical instruction skills." },
  { id: "content-writing", icon: PenLine, name: "Content Writing", duration: "120 Hours", price: 315, desc: "Copywriting, blogging, SEO writing, technical writing, and editorial skills." },
  { id: "personality-development", icon: UserCircle2, name: "Skill & Personality Development", duration: "120 Hours", price: 315, desc: "Communication, leadership, soft skills, interview prep, and confidence building." },
  { id: "governance", icon: Building2, name: "Polity & Governance Program", duration: "120 Hours", price: 315, desc: "Indian polity, public administration, governance models, and civic engagement." },
  { id: "biosciences", icon: BookOpen, name: "Biosciences & Sustainability", duration: "120 Hours", price: 315, desc: "Life sciences, environment, biotechnology, and sustainable practices." },
  { id: "course-related", icon: BookOpen, name: "Course Related", duration: "120 Hours", price: 315, desc: "Customized internship aligned with your degree (B.A., B.Sc., B.Com., BBA, etc.)." },
];

const ProgramsPage = () => (
  <div className="min-h-screen bg-slate-50">
    <MarketingHeader />
    <section className="bg-slate-900 py-14 text-white sm:py-20">
      <div className="marketing-container">
        <div className="max-w-3xl">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-blue-400 mb-3">Internship Programs</div>
          <h1 className="font-heading text-4xl font-bold tracking-tight md:text-6xl">
            14 industry-aligned tracks. One platform.
          </h1>
          <p className="mt-5 text-base leading-8 text-slate-300 sm:text-lg">
            Each program is a structured 120-hour internship with mentor support, hands-on assignments, attendance tracking, and a verifiable certificate.
          </p>
        </div>
      </div>
    </section>

    <section className="section-padding">
      <div className="marketing-container">
        <div className="grid gap-4 md:grid-cols-2 md:gap-6 lg:grid-cols-3">
          {PROGRAMS.map((p) => (
            <div key={p.id} data-testid={`program-card-${p.id}`} className="rounded-2xl border border-slate-200 bg-white p-5 transition-all hover:-translate-y-1 hover:shadow-md mobile-premium-card sm:p-6">
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-blue-50">
                <p.icon className="w-6 h-6 text-blue-600" strokeWidth={2} />
              </div>
              <h3 className="font-heading font-semibold text-lg text-slate-900 mb-2">{p.name}</h3>
              <p className="mb-4 text-sm leading-7 text-slate-600">{p.desc}</p>
              <div className="flex items-center justify-between pt-4 border-t border-slate-100">
                <div className="flex items-center gap-1.5 text-xs text-slate-500">
                  <Clock className="w-3.5 h-3.5" /> {p.duration}
                </div>
                <div className="font-heading text-xs font-bold uppercase tracking-wide text-blue-600">Fee according to course</div>
              </div>
              <Link to="/register" state={{ selectedProgramId: p.id }} className="mt-4 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-slate-900 px-4 py-3 text-sm font-semibold text-white transition-all hover:bg-slate-800">
                Enroll Now <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
    <Footer />
  </div>
);

export default ProgramsPage;
